module.exports = {
    "Empty": `Vac\xedo`
};


//# sourceMappingURL=es-ES.main.js.map
